import { Box, Button, Flex, Text } from '@chakra-ui/react';

export default function IconTabButtons({
	tabs = [],
	activeTab = false,
	orientation = 'horizontal',
	layout = 'home',
	wrapperProps = {},
	buttonProps = {},
}) {
	return (
		<Flex px={6} direction='column' {...wrapperProps}>
			<Flex
				direction={orientation === 'vertical' ? 'column' : 'row'}
				gap={4}
				mt={4}
				mb={2}
			>
				{tabs.map(({ label, icon: IconComponent, onClick, isActive }) => (
					<Flex
						key={label}
						direction='column'
						justifyContent='center'
						alignItems='center'
						gap={2}
					>
						<Button
							variant={isActive ? 'solid' : 'outline'}
							onClick={onClick}
							bg={isActive && 'brand.500'}
							color={isActive && 'gray.100'}
							display='flex'
							alignItems='center'
							{...buttonProps}
						>
							<Box
								as={IconComponent}
								sx={{
									mr: { base: 0, md: 2 },
									fontSize: { base: '18px', sm: '24px' },
								}}
							/>
							<Text display={{ base: 'none', md: 'inline' }}>
								{label.charAt(0).toUpperCase() + label.slice(1)}
							</Text>
						</Button>
					</Flex>
				))}
			</Flex>
			{layout === 'list' && activeTab && (
				<Text mt={3} display={{ base: 'inline', md: 'none' }}>
					{activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
				</Text>
			)}
		</Flex>
	);
}
